import {
    PaymentCardState,
    PaymentDetails,
    PaymentMethodType,
    PaymentState,
    PaymentTableRecordPaymentStatus,
    SepaDirectDebitProviderState,
} from '@mews-commander/data-access';
import { PaymentMethodImageType } from '@mews/business-components';
import { TagVariant } from '@optimus-web/core';

export const paymentStatusToTagVariantMap: Record<PaymentTableRecordPaymentStatus, TagVariant> = {
    [PaymentTableRecordPaymentStatus.Charged]: 'lime',
    [PaymentTableRecordPaymentStatus.Canceled]: 'basicBold',
    [PaymentTableRecordPaymentStatus.Pending]: 'primary',
    [PaymentTableRecordPaymentStatus.Failed]: 'danger',
    [PaymentTableRecordPaymentStatus.Verifying]: 'primary',
    [PaymentTableRecordPaymentStatus.WithBank]: 'primary',
    [PaymentTableRecordPaymentStatus.Settled]: 'basicBold',
};

export const paymentMethodImageTypeMap: Record<PaymentMethodType, PaymentMethodImageType> = {
    [PaymentMethodType.Ideal]: PaymentMethodImageType.Ideal,
    [PaymentMethodType.PaymentCard]: PaymentMethodImageType.PaymentCard,
    [PaymentMethodType.ApplePay]: PaymentMethodImageType.ApplePay,
    [PaymentMethodType.GooglePay]: PaymentMethodImageType.GooglePay,
    [PaymentMethodType.SepaDirectDebit]: PaymentMethodImageType.SepaDirectDebit,
    [PaymentMethodType.Other]: PaymentMethodImageType.PaymentCard,
};

export const paymentCardStateTagVariantMap: Record<PaymentCardState, TagVariant> = {
    [PaymentCardState.Enabled]: 'primary',
    [PaymentCardState.Disabled]: 'warning',
    [PaymentCardState.Expired]: 'danger',
};

export const sepaStateTagVariantMap: Record<SepaDirectDebitProviderState, TagVariant> = {
    [SepaDirectDebitProviderState.Enabled]: 'primary',
    [SepaDirectDebitProviderState.Disabled]: 'warning',
};

export const isFailedOrPendingPaymentStatus = (status: PaymentDetails['status']) =>
    status === PaymentState.Failed || status === PaymentState.Pending;
